import classNames from 'classnames';

import styles from './Spinner.module.css';

type Props = {
  className?: string;
};

export const Spinner = ({ className }: Props) => {
  return <div className={classNames(styles.spinner, className)}></div>;
};
